import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AccountService, AlertService } from '@app/_services';

@Component({ templateUrl: 'captcha.component.html' })
export class CaptchaComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  siteKey: string;
  constructor(

    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private alertService: AlertService

  ) { this.siteKey = "6LcxPbsaAAAAALkUgRQ4h961mkqYDMLdgZmcPEqi"; }

  ngOnInit() {
    this.form = this.formBuilder.group({   
      recaptcha: ['', Validators.required]
    });

    // get return url from route parameters or default to '/'
  
  }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.router.navigate(['captcha']);
  }
}
